<form [formGroup]="paymentService.entity">
  <div class="grid">
    <div class="col-12 md:col-6 xl:col-4">
      <div class="field">
        <label for="client"> <span class="p-error">*</span>Cliente: </label>
        <div class="flex justify-content-center flex-column">
          <p-dropdown
            formControlName="client"
            appendTo="body"
            [style]="{ height: '45px' }"
            scrollHeight="200px"
            [options]="paymentService.clients"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            filterBy="label"
            [showClear]="true"
            placeholder="Cliente al que pertenece el pago"
          >
          </p-dropdown>
          <ng-container
            *ngIf="
              paymentService.entity.get('client')?.invalid &&
              (paymentService.entity.get('client')?.dirty || paymentService.entity.get('client')?.touched)
            "
          >
            <small class="p-error" *ngIf="paymentService.entity.get('client')?.errors?.['required']"
              >El cliente al que pertenece el pago es obligatorio.</small
            >
          </ng-container>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-6 xl:col-4">
      <div class="field">
        <label for="account"> <span class="p-error">*</span>CLABE receptora: </label>
        <div class="flex justify-content-center flex-column">
          <p-dropdown
            formControlName="account"
            appendTo="body"
            [style]="{ height: '45px' }"
            scrollHeight="150px"
            [options]="paymentService.accounts"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            filterBy="label"
            [showClear]="true"
            placeholder="Selecciona una cuenta"
          >
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center" *ngIf="paymentService.entity.get('account')?.value">
                <div>{{ paymentService.getAccountName(paymentService.entity.get('account')?.value) }}</div>
              </div>
            </ng-template>
            <ng-template let-account pTemplate="item">
              <div class="flex align-items-center">
                <div>{{ account.label }}</div>
              </div>
            </ng-template>
          </p-dropdown>
          <ng-container
            *ngIf="
              paymentService.entity.get('account')?.invalid &&
              (paymentService.entity.get('account')?.dirty || paymentService.entity.get('account')?.touched)
            "
          >
            <small class="p-error" *ngIf="paymentService.entity.get('account')?.errors?.['required']">La cuenta es obligatoria.</small>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-6 xl:col-4">
      <div class="field">
        <label for="paymentMethod"> <span class="p-error">*</span>Método de pago: </label>
        <div class="flex justify-content-center flex-column">
          <p-dropdown
            formControlName="paymentMethod"
            appendTo="body"
            [style]="{ height: '45px' }"
            scrollHeight="150px"
            [options]="paymentService.paymentMethods"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            filterBy="label"
            [showClear]="true"
            placeholder="Selecciona un método de pago"
          >
          </p-dropdown>
          <ng-container
            *ngIf="
              paymentService.entity.get('paymentMethod')?.invalid &&
              (paymentService.entity.get('paymentMethod')?.dirty || paymentService.entity.get('paymentMethod')?.touched)
            "
          >
            <small class="p-error" *ngIf="paymentService.entity.get('paymentMethod')?.errors?.['required']"
              >El método de pago es obligatorio.</small
            >
          </ng-container>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-6 xl:col-4">
      <div class="field">
        <label for="amount"> <span class="p-error">*</span>Monto del pago: </label>
        <p-inputNumber formControlName="amount" inputId="amount" mode="currency" currency="MXN" locale="es-MX"></p-inputNumber>
        <ng-container
          *ngIf="
            paymentService.entity.get('amount')?.invalid &&
            (paymentService.entity.get('amount')?.dirty || paymentService.entity.get('amount')?.touched)
          "
        >
          <small class="p-error" *ngIf="paymentService.entity.get('amount')?.errors?.['required']">El monto es obligatorio.</small>
          <small class="p-error" *ngIf="paymentService.entity.get('amount')?.errors?.['min']"
            >El valor mínimo es {{ paymentService.entity.get('amount')?.errors?.['min']['min'] }}.</small
          >
        </ng-container>
      </div>
    </div>

    <div class="col-12 md:col-6 xl:col-4">
      <div class="field">
        <label for="trackingKey"> <span class="p-error">*</span>Clave de rastreo: </label>
        <input type="text" pInputText id="trackingKey" formControlName="trackingKey" placeholder="Clave de rastreo" />
        <ng-container
          *ngIf="
            paymentService.entity.get('trackingKey')?.invalid &&
            (paymentService.entity.get('trackingKey')?.dirty || paymentService.entity.get('trackingKey')?.touched)
          "
        >
          <small class="p-error" *ngIf="paymentService.entity.get('trackingKey')?.errors?.['required']"
            >La clave de rastreo es obligatoria.</small
          >
        </ng-container>
      </div>
    </div>

    <div class="col-12 md:col-6 xl:col-4">
      <div class="field">
        <label for="date"> <span class="p-error">*</span>Fecha de pago: </label>
        <input type="date" pInputText id="date" formControlName="date" required />
        <ng-container
          *ngIf="
            paymentService.entity.get('date')?.invalid &&
            (paymentService.entity.get('date')?.dirty || paymentService.entity.get('date')?.touched)
          "
        >
          <small class="p-error" *ngIf="paymentService.entity.get('date')?.errors?.['required']">La fecha de pago es obligatoria.</small>
        </ng-container>
      </div>
    </div>
  </div>
</form>
